export enum EUserRole {
  GlobalAdmin = 'GlobalAdmin',
  CompanyAdmin = 'CompanyAdmin',
  EventAdmin = 'EventAdmin',
  TeamAdmin = 'TeamAdmin',
  User = 'User'
}
